import {isEmpty, isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {SourcingTableName} from '../types/SourcingTableName';

export type SourcingViewMode = 'table' | 'cards' | 'map';
const MAP_SELECTED_VEHICLE_KEY = 'sourcing-classifieds-map-selected-vehicle-id';

function getIdKey(tableName: SourcingTableName) {
  return `sourcing-table--last-visited-vehicle-id/${tableName}`;
}

function getPageKey(tableName: SourcingTableName) {
  return `sourcing-table--last-visited-page/${tableName}`;
}

export const sourcingTableSessionStorage = {
  setMapSelectedVehicleId(adId: string | null) {
    sessionStorage.setItem(MAP_SELECTED_VEHICLE_KEY, adId ?? '');
  },
  getMapSelectedVehicleId(): string | null | undefined {
    const adId = sessionStorage.getItem(MAP_SELECTED_VEHICLE_KEY);
    return adId === null ? undefined : adId || null;
  },
  setLastVisitedVehicleId(tableName: SourcingTableName, adId: string) {
    sessionStorage.setItem(getIdKey(tableName), adId);
  },
  getLastVisitedVehicleId(tableName: SourcingTableName) {
    return sessionStorage.getItem(getIdKey(tableName)) || null;
  },
  setLastVisitedPage(tableName: SourcingTableName, page: number) {
    sessionStorage.setItem(getPageKey(tableName), page.toString());
  },
  getLastVisitedPage(tableName: SourcingTableName): number | null {
    const page = sessionStorage.getItem(getPageKey(tableName));
    return isNil(page) || isEmpty(page) ? null : parseInt(page);
  },
  setLastSelectedView(isDetailedView: boolean) {
    sessionStorage.setItem('sourcing-table--last-selected-view', isDetailedView.toString());
  },
  getLastSelectedView(): boolean {
    const view = sessionStorage.getItem('sourcing-table--last-selected-view');
    return isNilOrEmpty(view) ? false : view === 'true';
  },
  setAllOffersViewMode(mode: SourcingViewMode) {
    sessionStorage.setItem('sourcing-table--all-offers-view', mode);
  },
  getAllOffersViewMode(): SourcingViewMode {
    const mode = sessionStorage.getItem('sourcing-table--all-offers-view');
    if (mode === 'table' || mode === 'cards' || mode === 'map') {
      return mode;
    }
    return sessionStorage.getItem('sourcing-table--last-selected-view') === 'true'
      ? 'cards'
      : 'table';
  },
};
